import { FETCH_PAYMENTS_SUCCESS_ACTION } from "./action";

const initialState = {
  processing: false,
  error: false,
};

export default function (state: any = initialState, action: Function) {
  switch (action.type) {
    case FETCH_PAYMENTS_SUCCESS_ACTION:
      return {
        ...state,
        paymentsList: action.payload.rows,
        paymentsListCount: action.payload.count,
      };
    
    default:
      return {
        ...state,
      };
  }
}
